import React, { useState, useCallback } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import * as modalActions from '../../redux/actions/modal-actions';
import chroma from 'chroma-js';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import * as Icons from '@mui/icons-material';
import {
  Button,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import GeneralText from '../../stories/general-components/GeneralText';
import Modules from '../../components/@generalComponents/layout/Modules';


const PagesNav = ({ isTablet, tasksOpen }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname: currentPath } = useLocation();
  const { moduleId } = useParams();

  const { t, i18n } = useTranslation();
  const currentlangCode = i18n.language;
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';


  const [anchorEl, setAnchorEl] = useState(null);
  const [pulseAnchorEl, setPulseAnchorEl] = useState(null);


  const handleMenuOpen = (event) => {

    if (currentPath?.startsWith('/pulse')) {
      setPulseAnchorEl(event.currentTarget);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setPulseAnchorEl(null);
  };

  const businessPreference = useSelector((state) => state.core.businessData);
  const businessStructure = useSelector(
    (state) => state.core.businessStructure
  );

  const businessStructures = businessStructure?.structures || [];

  const modules = businessPreference?.menu || [];
  const currentSectionState = useSelector((state) => state.core.currentSection);
  const notifs = useSelector((state) => state.core.notifs);
  const activeModule = modules?.find((m) => m.id === moduleId);

  const currentUser = useSelector((state) => state.core.user);

  const currentUserGroups = currentUser?.activeBusiness?.groups || [];




  const openModalScan = () => {
    dispatch(
      modalActions.modalScan({
        isOpen: true,
      })
    );
  };




  const businessModules = businessPreference?.menu?.filter(
    (module) => module?.section === currentSectionState
  );


  const openAddElementModal = (structureId) => {
    dispatch(
      modalActions.modalElementCreation({
        isOpen: true,
        structureId: structureId,
      })
    );
    handleMenuClose();
  };

  const openPulseModal = (type) => {
    dispatch(
      modalActions.modalPulseCreation({
        isOpen: true,
        type: type,
      })
    );
    handleMenuClose();
  };



  const navigateExtension = (idExt) => {
    navigate('/bos' + idExt + '?tab=0');
  };



  const darkColor = () => {
    let finalColor = businessPreference?.mainColor || '#000000';

    return chroma(finalColor).darken(0.9).hex();
  };



  const RestrictedModule = ({ children }) => {
    if (
      currentSectionState === 'SETTINGS' ||
      currentSectionState === 'TOOLS' ||
      currentSectionState === 'MYNODE' ||
      currentSectionState === 'NODE'
    ) {
      return null;
    }
    return children;
  };

  const handleOpenMarketplace = () => {
    dispatch(
      modalActions.modalConnector({
        isOpen: true,
      })
    );
  }






  return (
    <div>

      {(currentUser?.activeBusiness?.role === 'SUPER-ADMIN' ||
        currentUser?.activeBusiness?.role === 'ADMIN' ||
        currentUser?.activeBusiness?.role === 'EMPLOYEE') &&
        (currentPath?.startsWith('/bos') || currentPath?.startsWith('/pulse')) && (
          <div
            style={{
              paddingRight: isTablet ? '0px' : '16px',
              paddingLeft: isTablet ? '0px' : '16px',
              marginTop: isTablet ? '8px' : '22px',
            }}
            className={isTablet ? 'mb-3 align-c' : 'mb-4 px-1 d-flex align-c'}
          >
            <Button
              onClick={handleMenuOpen}
              className="middle-content"
              fullWidth={isTablet ? false : true}
              sx={{
                zIndex: 100,
                width: isTablet ? '32px' : '180px',
                maxWidth: isTablet ? '32px !important' : '180px',
                minWidth: isTablet ? '32px !important' : '180px',
                height: isTablet ? '32px' : '34px',
                background: `linear-gradient(145deg, ${businessPreference?.mainColor || '#FF6F91'
                  }, ${darkColor()})`,
                borderRadius: '8px',
                padding: isTablet ? '0.4rem' : '0.6rem',
                boxShadow: `0px 4px 10px rgba(0, 0, 0, 0.2),
                          0px -2px 4px rgba(255, 255, 255, 0.3) inset`,
                color: '#FFFFFF',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  background: `linear-gradient(145deg,${darkColor()}, ${businessPreference?.mainColor || '#FF6F91'
                    })`,
                  boxShadow: `0px 6px 15px rgba(0, 0, 0, 0.3),
                            0px -3px 6px rgba(255, 255, 255, 0.4) inset`,
                  transform: 'scale(1.05)',
                  cursor: 'pointer',
                },
                '&:active': {
                  transform: 'scale(1)',
                  boxShadow: `0px 3px 8px rgba(0, 0, 0, 0.2),
                            0px -2px 3px rgba(255, 255, 255, 0.3) inset`,
                },
              }}
            >
              <Icons.AddOutlined
                fontSize="medium"
                htmlColor={'#FFF'}
                sx={{
                  marginRight: isTablet ? '0px' : '10px',
                }}
              />
              {!isTablet && (
                <Typography
                  fontWeight={600}
                  fontSize="12px"
                  color={'#FFF'}
                  variant="body2"
                >
                  {t('new')}
                </Typography>
              )}
            </Button>

            <Menu
              anchorEl={pulseAnchorEl}
              open={Boolean(pulseAnchorEl)}
              onClose={handleMenuClose}
              elevation={2}
              sx={{
                '& .MuiPaper-root': {
                  borderRadius: '8px 8px',
                  marginLeft: '10px',
                  width: '198px',
                  maxHeight: 300,
                  overflowY: 'auto',
                },
              }}

            >

              <MenuItem
                divider
                dense
                key={'dashboard'}
                onClick={() => openPulseModal('dashboard')}
              >
                <div className="middle-content d-flex">
                  <Icons.DashboardCustomizeOutlined color="secondary" fontSize="small" />
                  <div className="px-3">{t('dashboard')}</div>
                </div>
              </MenuItem>
              <MenuItem
                divider
                dense
                key={'report'}
                onClick={() => openPulseModal('report')}
              >
                <div className="middle-content d-flex">
                  <Icons.SummarizeOutlined color="secondary" fontSize="small" />
                  <div className="px-3">{t('report')}</div>
                </div>
              </MenuItem>
            </Menu>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              elevation={2}
              sx={{
                '& .MuiPaper-root': {
                  borderRadius: '8px 8px',
                  marginLeft: '10px',
                  width: '198px',
                  maxHeight: 300,
                  overflowY: 'auto',
                },
              }}

            >
              {businessStructures
                ?.slice()
                .sort((a, b) => a[`name`]?.localeCompare(b[`name`]))
                ?.filter(
                  (structure) =>
                    structure?.element?.preferences?.creation !== false
                )
                ?.map((structure) => {
                  const IconComponent =
                    Icons[structure?.icon] || Icons.HelpOutline;
                  return (
                    <MenuItem
                      divider
                      dense
                      key={structure?.id + 'structure'}
                      onClick={() => openAddElementModal(structure?.id)}
                    >
                      <div className="middle-content d-flex">
                        <IconComponent color="secondary" fontSize="small" />
                        <div className="px-3">{structure?.name}</div>
                      </div>
                    </MenuItem>
                  );
                })}
            </Menu>
          </div>
        )}

      <div className="mt-4" style={{ paddingLeft: isTablet ? '' : '16px' }}>
        {currentSectionState === 'SETTINGS' && (
          <GeneralText
            text={t('myNode')}
            primary={false}
            color={businessPreference?.mainColor}
            fontSize="18px"
            size="bold"
          />
        )}


        {isTablet && (
          <>
            <div
              style={{
                paddingTop: '0.21rem',
                paddingBottom: '0.2rem',
                marginLeft: isTablet ? '0px' : '',
              }}
              key={module.id + 'module'}
              className="mt-1 mb-1"
            >
              <div
                onClick={openModalScan}
                className={`${isTablet ? 'd-flex align-c' : 'd-flex'
                  } middle-content hover`}
              >
                <div className="align-c">
                  <Icons.QrCodeScannerOutlined
                    fontSize="medium"
                    htmlColor={isDarkMode ? '#FFF' : '#000'}
                    sx={{
                      fontSize: isTablet ? '21px' : '18px',
                      paddingRight: isTablet ? '1px' : '3px',
                      marginTop: '3px',
                    }}
                  />
                </div>
                {!isTablet && (
                  <div className="row d-flex justify-content-between">
                    <div className="align-left px-4">
                      <Typography
                        fontWeight={tasksOpen ? 600 : 500}
                        fontSize="13px"
                        sx={{
                          '&:hover': {
                            fontWeight: 600,
                          },
                        }}
                        color={isDarkMode ? '#FFF' : '#000'}
                        variant="body2"
                      >
                        {t('scan')}
                      </Typography>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>

      <div
        className="align-c mt-3"
        style={{
          paddingLeft: isTablet ? '' : '10px',
        }}
      >

        <Modules
          businessModules={businessModules}
          main={true}
          isTablet={isTablet}
          isDarkMode={isDarkMode}
          activeModule={activeModule}
          businessPreference={businessPreference}
          navigate={navigate}
          currentSectionState={currentSectionState}
        />


      </div>
    </div>
  );
};

export default PagesNav;
